import { Component } from '@angular/core';
import { MainFrontendConfigFieldAccess } from 'src/modules/app-template/netgen/MainFrontendConfigFieldAccess';
import { DatabaseUser } from 'src/modules/database/shared/database-user.entity';
import { TableData } from 'src/modules/sm-base/models/table-data.model';
import { TableRow } from 'src/modules/sm-base/models/table-row.model';
import { TableCellType } from 'src/modules/sm-base/netgen/TableCellType';
import { TableColumn } from 'src/modules/sm-base/netgen/TableColumn';
import { Arrays } from 'src/modules/utils/shared/arrays';
import { Objects } from "src/modules/utils/shared/objects";
import { EntityDefinition } from "../../models/entity-definition.model";
import { AdminBaseListComponent } from "../admin-base-list/admin-base-list.component";

@Component({
    selector: 'app-edit-general-users',
    templateUrl: '../../../sm-base/components/admin-base-list/admin-base-list.component.html',
    standalone: false
})
export class EditGeneralUsersComponent extends AdminBaseListComponent<DatabaseUser> {

    static staticDefinition = Objects.fromPlain(EntityDefinition<DatabaseUser>, {
        type: DatabaseUser,
        name: "Benutzer",
        namePlural: "Benutzer",
        category: "Benutzer",
        icon: "fas fa-user",
        apiEndpoint: "api/app/user",
        adminListUrl: "/base2/admin/editGeneralUsers"        
    });

    definition = Objects.with(Objects.fromPlain(EntityDefinition<DatabaseUser>, EditGeneralUsersComponent.staticDefinition), "canInsert", this.app.mainConfig.adminUsersAllowAdd);

    getTable(): TableData {
        return new TableData([
            new TableColumn("userName", "Benutzername", TableCellType.string, 20),
            this.applyFieldAccess(new TableColumn("lastName", "Nachname", TableCellType.string, 20)),
            this.applyFieldAccess(new TableColumn("firstName", "Vorname", TableCellType.string, 20)),
            this.applyFieldAccess(new TableColumn("mail", "E-Mail", TableCellType.string, 30)),
            this.applyFieldAccess(new TableColumn("phone", "Telefon", TableCellType.string, 15)),
            this.applyFieldAccess(new TableColumn("isAdmin", "Administrator", TableCellType.bool, 1)),
            this.applyFieldAccess(new TableColumn("active", "Aktiv", TableCellType.bool, 1)),
            this.applyFieldAccess(new TableColumn("groups", "Gruppenzugehörigkeit", TableCellType.string, 30))
        ], this.listData.map(o => new TableRow("", o, {
            userName: o.userName,
            lastName: o.lastName,
            firstName: o.firstName,
            mail: o.mail,
            phone: o.phone,
            isAdmin: o.isAdmin,
            active: o.active,
            groups: Arrays.itemsToString(Arrays.sort(o.groups.map(g => g.name)))
        })), ["userName"]);
    }

    private applyFieldAccess(col: TableColumn): TableColumn {
        let fa = this.app.mainConfig.adminUsersFieldAccess;
        if (fa == null) {
            return col;
        }
        if (Objects.getSafe(fa, col.id, MainFrontendConfigFieldAccess.editable) == MainFrontendConfigFieldAccess.hidden) {
            return null;
        }
        return col;
    }

}